import { CACHE_TTL } from '../JucyCacheConstants.js';
export class MemoryStore {
    cache = new Map();
    getTimestamp() {
        return Date.now();
    }
    async get(key) {
        const response = this.cache.get(key);
        if (!response) {
            return undefined;
        }
        const expired = response.createdAt + response.ttl < this.getTimestamp();
        if (expired) {
            await this.delete(key);
            return undefined;
        }
        return response.data;
    }
    async set(key, data, ttl) {
        if (!key) {
            throw new Error('key is required');
        }
        this.cache.set(key, {
            data,
            ttl: ttl || CACHE_TTL.FIVE_MIN,
            createdAt: this.getTimestamp(),
        });
    }
    async delete(key) {
        this.cache.delete(key);
    }
    async ttl(key) {
        const item = this.cache.get(key);
        if (!item) {
            return 0;
        }
        const ttl = item.createdAt + item.ttl - this.getTimestamp();
        return ttl > 0 ? ttl : 0;
    }
}
